<div class="message-sender new-message-dialog">
  <app-section-title-h3
    [title]="data.text.modalTitle"
    [titleTooltip]="data.text.titleTooltip"
    [messageTooltip]="data.text.messageTooltip"
  ></app-section-title-h3>
  <div class="text-area-container">
    @if (requireTitle()) {
      <div class="input-cotainer">
        <app-form-input [label]="data.text.titleLabel" [placeholder]="''" [(model)]="title"></app-form-input>
        <div class="text-counter" [class.too-long]="checkIfTextIsTooLong(title, titleMaxLength)"
          >{{ getTextLength(title) }}/{{ titleMaxLength }}</div
        >
      </div>
    }
    @if (requireMessage()) {
      <div class="input-cotainer">
        <app-form-input
          [label]="data.text.messageLabel"
          [placeholder]="''"
          [(model)]="text"
          [textArea]="true"
        ></app-form-input>
        <div class="text-counter" [class.too-long]="checkIfTextIsTooLong(text, textMaxLength)"
          >{{ getTextLength(text) }}/{{ textMaxLength }}</div
        >
      </div>
      <app-validator-error-message
        [epValidator]="epValidator"
        [index]="0"
        [fieldName]="validatorFieldNames.message"
      ></app-validator-error-message>
    }
    @if (requireSelectBox()) {
      <div class="select-data">
        <h4>{{ data.text.selectBox.title | translate }}</h4>
        <div class="select-box">
          <app-form-select
            [errors]="null"
            [label]="data.text.selectBox.label"
            [placeholder]="data.text.selectBox.placeholder"
            [(model)]="chosenSelectOption"
            (modelChange)="getMessageAttachmentData()"
            [choices]="rabeTypeChoices"
            [valueName]="'key'"
            [optionName]="'label'"
          ></app-form-select>
          <app-validator-error-message
            [epValidator]="epValidator"
            [index]="0"
            [fieldName]="validatorFieldNames.rabe_type"
          ></app-validator-error-message>
        </div>
      </div>
    }

    @if (!isRabePreviewOnlyMode()) {
      <div class="attachments-container">
        <app-add-attachment-list
          [buttonText]="data.text.addFileButton"
          [attachmentsList]="attachmentsList"
          [maxFilesNumber]="getMaxFilesNumber()"
          [sendedAttachments]="sendedAttachments"
        ></app-add-attachment-list>
      </div>
    }
    @if (isRabePreviewOnlyMode()) {
      <div class="rabe-preview-list">
        @if (sendedAttachments.length === 0) {
          <div class="rabe-preview-empty">{{ "COMMON.EMPTY_LIST" | translate }}</div>
        }
        @for (attachment of sendedAttachments; track attachment.id) {
          <button type="button" class="rabe-preview-list__item" (click)="openRabeAttachmentPreview(attachment.id)">
            <i class="fa fa-file-o" aria-hidden="true"></i>
            <span>{{ attachment.file }}</span>
          </button>
        }
      </div>
    }
    @if (requireEnforcement()) {
      <div class="input-cotainer mb-20">
        <mat-checkbox [(ngModel)]="requireEnforcementValue" [attr.data-cy]="'checkboxFiledTogether'">
          <span class="checkbox_txt">{{ data.text.checkboxText | translate }}</span>
        </mat-checkbox>
      </div>
    }
    @if (requireDecisionDate()) {
      <div class="input-cotainer mb-20">
        <app-form-date-input
          [label]="'SEND_MESSAGE_DIALOG.APPEAL.DATE'"
          [(model)]="localDecisionDate"
          [noYear]="false"
          [placeholder]="'COMMON.DATE_FORMAT'"
        >
        </app-form-date-input>
      </div>
      <app-validator-error-message
        [epValidator]="epValidator"
        [index]="0"
        [fieldName]="validatorFieldNames.message"
      ></app-validator-error-message>
    }
  </div>
  @if (requireSendByEmail()) {
    <div class="input-cotainer mb-20">
      <mat-checkbox [(ngModel)]="sendByEmail" [attr.data-cy]="'checkboxFiledTogether'">
        <span class="checkbox_txt">{{ data.text.sendByEmailText | translate }}</span>
      </mat-checkbox>
    </div>
  }
  <div class="text-area-container">
    @if (requireIdNumber()) {
      <div class="input-cotainer mb-20">
        <app-form-input
          [errors]="errors?.identifikationsnummer"
          [shouldRenderErrors]="true"
          [label]="'INPUT.IDENTIFIKATIONSNUMMER.LABEL'"
          [placeholder]="'INPUT.DEFAULT.PLACEHOLDER'"
          [(model)]="localIdNumber"
        ></app-form-input>
        <app-validator-error-message
          [epValidator]="epValidator"
          [index]="0"
          [fieldName]="validatorFieldNames.id_number"
        ></app-validator-error-message>
      </div>
    }
    @if (requireSteuernummer()) {
      <div class="input-cotainer mb-20">
        <app-form-input
          [errors]="errors?.steuernummer"
          [shouldRenderErrors]="true"
          [label]="'INPUT.STEUERNUMMER.LABEL'"
          [currentInputId]="'applicantSteuernummer'"
          [placeholder]="'INPUT.DEFAULT.PLACEHOLDER'"
          [(model)]="localSteuernummer"
        ></app-form-input>
        <app-validator-error-message
          [epValidator]="epValidator"
          [index]="0"
          [fieldName]="validatorFieldNames.tax_number"
        ></app-validator-error-message>
      </div>
    }
    @if (requireTaxAuthority()) {
      <div class="input-cotainer mb-20">
        <app-personal-info-tax-authority
          [taxAuthority]="localTaxAuthority"
          (setTaxAuthority)="localTaxAuthority = $event"
          [taxAuthorities]="dataSelects.taxAuthorities"
          [errors]="errors?.tax_authority"
        ></app-personal-info-tax-authority>
        <app-validator-error-message
          [epValidator]="epValidator"
          [index]="0"
          [fieldName]="validatorFieldNames.tax_authority"
        >
        </app-validator-error-message>
      </div>
    }
  </div>
  @if (shouldShowEwrElsterInfoBox()) {
    <div class="ewr-info-box">
      <div class="ewr-info-box__icon">
        <i class="fa fa-info" aria-hidden="true"></i>
      </div>
      <div class="ewr-info-box__content">
        <p>{{ "SEND_MESSAGE_DIALOG.ATTACHMENT.EWR_ELSTER_INFO_TEXT" | translate }}</p>
        <button type="button" class="ewr-info-box__button" (click)="openElsterContactForm()">
          {{ "SEND_MESSAGE_DIALOG.ATTACHMENT.EWR_ELSTER_LINK" | translate }}
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  }
  @if (!isRabePreviewOnlyMode()) {
    <app-button-two
      [btnTextSecond]="getSubmitButtonText()"
      [btnTextFirst]="'SEND_MESSAGE_DIALOG.BUTTON_CANCEL'"
      (cancelEmitter)="closeModal()"
      (addEmitter)="handleSendMessage()"
      [isDisabled]="checkIfSendMessageIsDisabled()"
      [isLoading]="isLoading"
    ></app-button-two>
  }
  @if (isRabePreviewOnlyMode()) {
    <button type="button" class="rabe-preview-list__back" (click)="closeModal()">{{ "COMMON.BACK" | translate }}</button>
  }
  @if (errors?.rabe_general?.length > 0) {
    <div class="error">{{ errors.rabe_general[0] }}</div>
  }
  @if (isRequestError) {
    <div class="error">{{ "SEND_MESSAGE_DIALOG.ERROR.REQUEST" | translate }}</div>
  }
</div>
